module.exports = __webpack_public_path__ + "static/logo-04d4e3fc659dc83f5db644eaee328e39.png";